import { LocationManagementLocationType } from "./locationType";

export type LocationTypeMovementCondition = {
  id: string;
  fromLocationTypeId: string;
  toLocationTypeId: string;
  inventoryAttribute: string;
  conditionType: string;
  conditionValue: string;
  description: string;
  fromLocationType?: LocationManagementLocationType;
  toLocationType?: LocationManagementLocationType;
};

export const defaultLocationTypeMovementCondition: LocationTypeMovementCondition = {
  id: "",
  fromLocationTypeId: "",
  toLocationTypeId: "",
  inventoryAttribute: "",
  conditionType: "",
  conditionValue: "",
  description: "",
};
